import React from 'react';

const SvgComponent = (props) => (
  <svg
    version={1.1}
    x={0}
    y={0}
    viewBox="0 0 18 18"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    {...props}
  >
    <g>
      <path d="M0 4.5l9 9 9-9z" />
      <path d="M0 4.5h18v9H0z" />
    </g>
  </svg>
);

export default SvgComponent;
